<template>
  <div class="read-instructions">
    <div id="left-pane">
      <div class="test-details">
        <img id="image" src="../assets/timer.svg" alt="Fill Details" />
        <p id="sample-test">{{ $store.state.test.name }}</p>
        <table rules="rows" class="parent-test-details">
          <tr>
            <td class="test-details-left-column">By</td>
            <td class="test-details-right-column" style="color: #0988F4;">
              {{ $store.state.test.companyName }}
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Duration</td>
            <td class="test-details-right-column">
              {{ $store.getters.getDuration }} hours
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Opens At</td>
            <td class="test-details-right-column">{{ getFormattedDate }}</td>
          </tr>
        </table>
      </div>
      <div class="help-section">
        <hr class="horizontal-line" />
        <div class="help-div">
          <p id="help-support">Help and support</p>
          <p class="contact-administrator">
            You can contact the test administrator at
            <a
              href="mailto:headstart-support@infocusp.com"
              target="_top"
              style="color: #319BF5"
              >headstart-support@infocusp.com</a
            >
          </p>
          <!--<p class="contact-administrator">
            OR
            <a
              href="https://meet.google.com/kbg-qghf-ody"
              target="_blank"
              style="color: #319BF5"
            >Join this link</a
            >
            to get help on video call
          </p>-->
        </div>
      </div>
    </div>
    <div class="right-pane">
      <div class="inner-white-div">
        <div class="timer-area">
          <div class="image-div">
            <img
              id="timer-image"
              src="../assets/timer_blue.svg"
              height="40px"
            />
          </div>
          <div class="starting-in">
            <span style="font-size:14px"
              >You can start solving problems in</span
            >
          </div>
          <div class="timer">00:{{ minutes }}:{{ seconds }}
          </div>
          <div class="start-test">
            <div v-if="submitCamError !== '' || submitMicError !== ''" class="submit-error-message">
              <span>{{ submitCamError }} <br v-if="submitCamError !== '' && submitMicError !== ''">
              {{ submitMicError }}</span>
            </div>
            <button
              :class="[
                !isDisabled ? 'start-test-button-active' : 'start-test-button',
              ]"
              :disabled="isDisabled"
              @click="startTest"
            >
              START TEST
            </button>
          </div>
          <div class="edit-details">
            <button class="edit-details-button" @click="editDetails">
              EDIT YOUR DETAILS
            </button>
          </div>
        </div>
        <div class="instructions">
          <div class="genInstuctions">
            <div class="general-instructions">
              General Instructions
            </div>
            <div style="display:flex; margin-top:10px; margin-left: 30px;">
              A question will always in one of the state defined by an
              easy-to-recongize symbol as below:
            </div>
            <div class="con">
              <div class="desCircle">
                <CircleComponent current-class="notActiveDot"></CircleComponent>
              </div>
              <div class="desc">Unattempted</div>
            </div>
            <div class="con">
              <div class="desCircle">
                <CircleComponent current-class="currentDot"></CircleComponent>
              </div>
              <div class="desc">Current Question</div>
            </div>
            <div class="con">
              <div class="desCircle">
                <CircleComponent
                  current-class="reviewSubmitDot"
                ></CircleComponent>
              </div>
              <div class="desc">"Answered" and Marked For Review</div>
            </div>
            <div class="con">
              <div class="desCircle">
                <CircleComponent current-class="reviewDot"></CircleComponent>
              </div>
              <div class="desc">
                "Unanswered" and Marked For Review
              </div>
            </div>
            <div class="con">
              <div class="desCircle">
                <CircleComponent current-class="savedDot"></CircleComponent>
              </div>
              <div class="desc">"Answered"</div>
            </div>
            <div class="instruction-detail">
              <span style="margin-bottom: 8px;">
                Mark-for-Review is a user friendly setting, intuitively
                indicating a review of a particular question. There are two
                sub-modes/scenarios as below:
              </span>
              <ul>
                <li style="margin-bottom: 8px;">
                  If a test-taker selects a particular option/answer and also
                  simultaneously asks the platform to "mark it for review" then
                  the selected option is considered for scoring and the
                  particular question is marked for review.
                </li>
                <li>
                  If a test-taker does not select any option/answer but asks the
                  platform to "mark it for review" then only the particular
                  question is marked for review and no other action is taken.
                </li>
              </ul>
              <span class="instruction-span" style="font-weight: bold">
                In brief, only the questions whose state-symbol is exhaustively
                or partly green (i.e. they are either "Answered" or "Answered
                and Marked For Review" state, respectively) are considered for
                scoring/evaluation.
              </span>
              <span class="instruction-span">
                The guide to these state-symbols will always be present
                on-screen during the test.
              </span>
              <span class="instruction-span" style="font-weight: bold">
                The test is set to be taken in Full-Screen mode. Platform
                auto-recognizes any switches between the tabs or leaving the
                test environment. Three warnings will be given post which the
                platform will auto-end the test.
              </span>
              <span class="instruction-span" style="font-weight: bold">
                You should give the test in Chrome, if you are using any other
                browser then close this tab and restart the test in Chrome.
              </span>
            </div>
          </div>
          <hr class="hr" />
          <div class="general-instructions">Description</div>
          <div class="instruction-detail" v-html="$store.state.test.description">
            {{ $store.state.test.description }}
          </div>
          <hr class="hr" />
          <div class="general-instructions">Instructions</div>
          <div class="instruction-detail" v-html="$store.state.test.instructions">
            {{ $store.state.test.instructions }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleComponent from '../components/Circle'
import { mapGetters } from 'vuex'
export default {
  name: 'ReadInstructions',
  components: { CircleComponent },
  data: function() {
    return {
      timer: null,
      totalTime: 5,
      timeOver: false,
      validateTimer: undefined,
      isAccessible: false,
      submitCamError: '',
      submitMicError: '',
    }
  },
  watch: {
    totalTime(newTime) {
      sessionStorage.totalTime = newTime
    },
  },
  mounted() {
    if(this.$store.state.currentStep !== 'read-instructions') {
      return;
    }
    if (sessionStorage.totalTime) {
      this.totalTime = sessionStorage.totalTime
    }
    this.startTimer()

    /*this.validateTimer = setInterval(() => {
      const currSec = new Date().getTime()
      const startSec = this.$store.state.test.startDateTime.getTime()
      const endSec = this.$store.state.test.endDateTime.getTime()

      if (currSec >= startSec && currSec <= endSec) {
        this.isAccessible = true
      } else if (currSec < startSec) {
        this.isAccessible = false
      } else {
        this.$router.replace({ path: '/error/3' })
      }
    }, 1000)*/
  },
  created() {
    if(this.$store.state.currentStep !== 'read-instructions') {
      var testId = this.$route.params.test_id
      var userId = this.$route.params.user_id
      this.$store.commit('setCurrentStep', 'webcam')
      this.$router.replace({ path: `/webcam/test/${testId}/user/${userId}` })
      return;
    }
    if (typeof this.$store.state.test.startDateTime === 'string') {
      this.$store.commit(
        'setStartDateTime',
        new Date(this.$store.state.test.startDateTime)
      )
    }
    if (typeof this.$store.state.test.endDateTime === 'string') {
      this.$store.commit(
        'setEndDateTime',
        new Date(this.$store.state.test.endDateTime)
      )
    }
  },
  methods: {
    async getCameraPermission(){
      try {
        await navigator.mediaDevices.getUserMedia({video: true}).then( (stream) =>{
          let tracks = stream.getTracks()
          tracks.forEach((track) => {
            track.stop()
          })
        })
        this.submitCamError = ''
        return true
      } catch {
        return false
      }
    },
    async getMicPermission(){
      try {
        await navigator.mediaDevices.getUserMedia({audio: true}).then( (stream) =>{
          let tracks = stream.getTracks()
          tracks.forEach((track) => {
            track.stop()
          })
        })
        this.submitMicError = ''
        return true
      } catch{
        return false
      }
    },
    async checkMediaDevices() {
      const devices = await navigator.mediaDevices.enumerateDevices()
      let micFound = devices.some(device => device.kind === "audioinput")
      let camFound = devices.some(device => device.kind === "videoinput")
      let devicesFound = {
        cam: camFound,
        mic: micFound
      }

      return devicesFound
    },
    editDetails() {
      var testId = this.$route.params.test_id
      var userId = this.$route.params.user_id
      this.$store.commit('setCurrentStep', 'fill-details')
      this.$router.replace({ path: `/fill-details/test/${testId}/user/${userId}`,})
    },
    startTimer() {
      this.timer = setInterval(() => this.countdown(), 1000)
    },
    countdown() {
      if (this.totalTime >= 1) {
        this.totalTime--
      } else {
        this.totalTime = 0
        this.timeOver = true
      }
    },
    padTime: function(time) {
      return (time < 10 ? '0' : '') + time
    },
    async startTest() {
      let devices = await this.checkMediaDevices()
      let camValidity = true
      let micValidity = true

      if(this.$store.state.webcamMandatory == true){
        let camPermission = await this.getCameraPermission();
        if(camPermission == false){
          this.submitCamError = 'Please give the browser permission to access camera'
          camValidity = false
        }
        if(devices['cam'] == false){
          this.submitCamError = 'You need to have a camera to give this test'
          camValidity = false
        }
      }
      if(this.$store.state.micMandatory == true){
        let micPermission = await this.getMicPermission();
        if(micPermission == false){
          this.submitMicError = 'Please give the browser permission to access microphone'
          micValidity = false
        }
        if(devices['mic'] == false){
          this.submitMicError = 'You need to have a microphone to give this test'
          micValidity = false
        }
      }
      if(camValidity && micValidity){
        this.launchIntoFullscreen(document.documentElement)
        this.$store.commit('setCurrentStep', 'questions')
        var testId = this.$route.params.test_id
        var userId = this.$route.params.user_id
        this.$router.replace({ path: `/questions/test/${testId}/user/${userId}` })
      }
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
  },
  computed: {
    ...mapGetters(['getFormattedDate']),
    minutes: function() {
      const minutes = Math.floor(this.totalTime / 60)
      return this.padTime(minutes)
    },
    seconds: function() {
      const seconds = this.totalTime % 60
      return this.padTime(seconds)
    },
    isDisabled() {
      return !this.timeOver
    },
  },
}
</script>
<style scoped>
.inner-white-div {
  flex: 1;
  padding: 16px;
  /*background: #ffffff;*/
  border-radius: 2px;
}
.desc,
.desCircle {
  font-size: 14px;
  margin-left: 10px;
}
.con {
  align-items: center;
  margin-top: 10px;
  margin-left: 30px;
  display: flex;
  flex-direction: row;
}

.genInstuctions {
  display: flex;
  flex-direction: column;
  font-family: Roboto-Regular;
}

.instruction-span {
  display: block;
  margin-top: 16px;
}

.horizontal-line {
  width: 326px;
  border: 0.5px solid #f2f2f2;
  padding-left: 18px;
  margin-right: 30px;
}

.test-details-right-column {
  font-family: Roboto-Medium;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 16px 0;
}

.test-details-left-column {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 0 32px;
}

.parent-test-details {
  border: none;
  margin-right: 32px;
  width: 346px;
}

.parent-test-details tr {
  border-top: solid thin;
  border-bottom: solid thin;
  border-color: #efeef3;
}

.contact-administrator {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  line-height: 20px;
}

#help-support {
  margin-top: 24px;
  font-family: Roboto-Bold;
  color: #616262;
  letter-spacing: 0;
}

#recommended-para {
  margin-top: 8px;
  color: #9b9b9b;
  line-height: 20px;
  font-family: Roboto-Regular;
}

.help-div {
  padding: 0px 32px;
  font-family: Roboto-Bold;
  letter-spacing: 0;
  font-size: 14px;
  margin-bottom: 32px;
}
#recommended {
  color: #616262;
}
.hr {
  width: 1300px;
  border: 0.5px solid #efeef3;
  margin: 24px 58px 0px 4px;
}
#image {
  display: block;
  margin: 24px auto;
  height: 200px;
  width: 216px;
}
#left-pane {
  background: #ffffff;
  /*box-shadow: inset -1px 0 0 0 #a8b2c6;*/
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  max-width: 376px;
  overflow-y: auto;
}
.practice-test {
  border: 1px solid #1bc09c;
  border-radius: 2px;
  background-color: white;
  color: #1bc09c;
  text-align: center;
  font-size: 12px;
  height: 30px;
  outline: #1bc09c;
  font-family: Roboto-Bold;
}

.practice-test:hover {
  background: #1bc09c;
  box-shadow: 0 10px 20px 0 rgba(27, 192, 156, 0.4);
  color: #f2f2f2;
  outline: #1bc09c;
  cursor: pointer;
}

.practice-test:active {
  background: #1bc09c;
  border: 1px solid #1bc09c;
  color: white;
  outline: #1bc09c;
}
#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}

.instruction-para {
  font-family: Roboto-Regular;
  letter-spacing: 0;
  margin-left: 25px;
  text-align: left;
  white-space: pre-wrap;
  font-size: 14px;
}
.instruction-para strong {
  color: #616262;
}

.edit-details {
  margin: 22px 16px 22px 6px;
}
.edit-details-button {
  background: #ffffff;
  border: 1px solid rgba(155, 155, 155, 0.2);
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #616262;
  width: 143px;
  height: 40px;
  outline: #1bc09c;
  cursor: pointer;
}

.edit-details-button:hover {
  background: #1bc09c;
  box-shadow: 0 10px 20px 0 rgba(27, 192, 156, 0.4);
  color: #ffffff;
  -webkit-transition: background-color 0.2s ease-out;
  -moz-transition: background-color 0.2s ease-out;
  -o-transition: background-color 0.2s ease-out;
  transition: background-color 0.2s ease-out;
}
.edit-details-button:focus {
  background: #1bc09c;
  color: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.submit-error-message {
  width: fit-content;
  padding: 9px;
  margin-top: 0px;
  margin-right: 8px;
  background-color: #fff6f6;
  color: #9f3a38;
  border: 1px solid #9f3a38;
  border-radius: 5px;
  font-size: 12px;
}

.start-test {
  display: flex;
}

.start-test-button {
  background: #eeeeee;
  border: 1px solid rgba(155, 155, 155, 0.2);
  border-radius: 2px;
  width: 126px;
  height: 40px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #9b9b9b;
}
.start-test-button-active {
  border: 1px solid #0988f4;
  border-radius: 2px;
  width: 126px;
  height: 40px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #0988f4;
  background-color: white;
  cursor: pointer;
  outline: #0988f4;
}
.start-test-button-active:hover {
  background: #319bf5;
  box-shadow: 0 10px 20px 0 rgba(49, 155, 245, 0.4);
  color: #ffffff;
  -webkit-transition: background-color 0.2s ease-out;
  -moz-transition: background-color 0.2s ease-out;
  -o-transition: background-color 0.2s ease-out;
  transition: background-color 0.2s ease-out;
}
.start-test-button-active:focus {
  background: #319bf5;
  color: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.timer-area {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 2px;
  margin-bottom: 16px;
  min-height: 84px;
}

.instructions {
  /*margin: 0px 50px 50px 50px;*/
  background: #ffffff;
  border-radius: 2px;
  flex-grow: 1;
  font-size: 16px;
  color: #69758b;
}

.general-instructions {
  font-family: Roboto-Regular;
  font-size: 21px;
  color: #616262;
  letter-spacing: -0.29px;
  width: 100%;
  height: fit-content;
  text-align: left;
  margin-left: 25px;
  padding-top: 27px;
}

.image-div {
  width: 50px;
  display: flex;
  flex-direction: column;
}

.starting-in {
  font-family: Roboto-Regular;
  height: 16px;
  width: 220px;
  font-size: 15px;
  color: #69758b;
  text-align: left;
}

.timer {
  flex: 1;
  font-family: Roboto-Bold;
  font-size: 30px;
  color: #1bc09c;
  width: 121px;
  height: 35px;
  align-items: center;
  display: flex;
}

#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}
.read-instructions {
  display: flex;
  margin-top: 64px;
  flex: 1;
  max-height: calc(100% - 64px);
}

.right-pane {
  flex: 1;
  text-align: center;
  background: #efeef3;
  color: #69758b;
  overflow: auto;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.instruction-detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 16px;
  margin-left: 30px;
  font-size: 15px;
  text-align: justify;
  padding-right: 32px;
}

.help-section {
  margin-top: auto;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #ada2a2;
}
#left-pane::-webkit-scrollbar-thumb {
  background-color: #d0d0d0;
}
@media only screen and (max-width: 1440px) {
  .image-div {
    width: 29px;
  }
  .hr {
    width: 96%;
  }
  .edit-details-button,
  .start-test-button,
  .start-test-button-active {
    font-size: 12px;
    height: 32px;
  }
  .general-instructions {
    font-size: 18px;
    padding-top: 18px;
  }
  #left-pane {
    max-width: 280px;
  }

  #image {
    margin: 24px auto;
    height: 150px;
    width: 168px;
  }
  .test-details-left-column {
    padding: 0 0 0 16px;
    font-size: 13px;
  }

  .test-details-right-column {
    font-size: 13px;
    padding: 8px 0;
    min-width: 170px;
  }
  .horizontal-line {
    display: none;
    width: 240px;
  }
  .parent-test-details {
    margin-right: 17px;
  }
  .help-div {
    font-size: 13px;
    padding: 0px 16px;
    margin-bottom: 20px;
  }
}
.block {
  border: none !important;
  font-size: 16px !important;
  padding: 0 25px !important;
  font-size: 15px !important;
  font-family: Roboto-Regular !important;
}
.block .ql-editor {
  padding: 12px 0px !important;
}
</style>
